// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#304156","menuText":"#bfcbd9","menuActiveText":"#ffd04b"};